module.exports = __webpack_public_path__ + "media/drop_off_bookings/page-69a59f63.png";